<template>
  <div class="container-md plr-0" >
    <div class="container-bg p-5 c-pro-wrap">
      <table class="table">
        <tbody>
          <tr>
            <td><h3 class="text-uppercase">Invoice</h3></td>
          </tr>
          <tr v-if="payment.invoice_date">
            <td>Invoice date</td>
            <td class="d-flex justify-content-center">
              {{ payment.invoice_date }}
            </td>
          </tr>
          <tr v-if="payment.amount">
            <td>Amount</td>
            <td class="d-flex justify-content-center">
              {{ Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(payment.amount) }}
            </td>
          </tr>
          <tr v-if="payment.invoice_data">
            <td>Invoice data</td>
            <td class="d-flex justify-content-center">
             {{ payment.invoice_data }}
            </td>
          </tr>
          <tr v-if="payment.payment_date">
            <td>Payment date</td>
            <td class="d-flex justify-content-center">
              {{ payment.payment_date }}
            </td>
          </tr>
          <tr v-if="payment.next_payment_date">
            <td>Next payment</td>
            <td class="d-flex justify-content-center">
              {{ payment.next_payment_date }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "profilePrivacy",
  data() {
    return {
        payment:{},
        loading: false,
    };
  },
  methods: {
      getPayment(){
      this.loading = true;
      this.$store.dispatch('get', `/api/v1/subscriptions/payments/${this.$route.params.payment_id}`)
      .then((data)=>{
        this.payment = data.data.data;
        this.loading = false;
      })
      .catch((error)=>{
        console.log(error)
        this.loading = false;
      })
      
    }
  },
  created() {
    this. getPayment();
  },
};
</script>
<style>
.all-check {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  margin-top: -0.4rem !important;
  margin-left: -1.5rem !important;
}
</style>
